import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { FaFileAlt } from 'react-icons/fa';
import { API_BASE_URL } from '../../config';
import YearSelector from '../../components/common/YearSelector';
import DeclaracionesJuradasTab from '../../components/DeclaracionRenta/DeclaracionesJuradasTab';
import useYearSelector from '../../hooks/useYearSelector';
import useDeclaracionesJuradas from '../../hooks/useDeclaracionesJuradas';
import '../../styles/pages/ServiciosSII/DeclaracionesJuradasPage.css';

const DeclaracionesJuradasPage = ({ token, id_company }) => {
    const [searchParams] = useSearchParams();
    const anioParam = Number(searchParams.get('anio')) || null;
    const [rutEmpresa, setRutEmpresa] = useState();
    const [regimenEmpresa, setRegimenEmpresa] = useState(null);

    // El RUT da nombre a los archivos que se descargan (DJ1948_<RUT>_<año>.csv, …). La
    // empresa elegida al entrar no lo trae, así que se pide aquí, como en Configuración.
    // De la misma respuesta sale el régimen tributario, que decide qué DJ se ofrecen.
    useEffect(() => {
        const buscarRut = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/company/companies/${id_company}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setRutEmpresa(response.data.rut);
                setRegimenEmpresa(response.data.regimen_tributario || null);
            } catch (error) {
                console.error('Error al obtener el RUT de la empresa:', error);
            }
        };
        buscarRut();
    }, [id_company, token]);

    const {
        selectedYear,
        setSelectedYear,
        yearOptions
    } = useYearSelector(anioParam, 1, 0);

    const {
        declaracionesJuradas,
        loading,
        createDeclaracionJurada,
        updateDeclaracionJurada,
        deleteDeclaracionJurada
    } = useDeclaracionesJuradas(selectedYear, id_company, token);

    return (
        <div className="declaraciones-juradas-page">
            <div className="page-header">
                <div className="header-content">
                    <div className="title-section">
                        <FaFileAlt className="page-icon" />
                        <div>
                            <h1>Declaraciones Juradas</h1>
                            <p className="page-subtitle">
                                Gestión de declaraciones juradas anuales
                            </p>
                        </div>
                    </div>
                    <YearSelector
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                        yearOptions={yearOptions}
                        label="Año Tributario"
                        className="header-year-selector"
                    />
                </div>
            </div>

            <div className="dj-content">
                <DeclaracionesJuradasTab
                    declaraciones={declaracionesJuradas}
                    selectedYear={selectedYear}
                    loading={loading}
                    onCreate={createDeclaracionJurada}
                    onUpdate={updateDeclaracionJurada}
                    onDelete={deleteDeclaracionJurada}
                    token={token}
                    idCompany={id_company}
                    rutEmpresa={rutEmpresa}
                    regimen={regimenEmpresa}
                />
            </div>

            <div className="page-footer">
                <p className="footer-info">
                    <strong>Nota:</strong> Las declaraciones juradas deben ser presentadas ante el SII
                    en los plazos establecidos para cada tipo de declaración.
                </p>
            </div>
        </div>
    );
};

export default DeclaracionesJuradasPage;
